module.exports = __webpack_public_path__ + "img/main-pic.ce74ab60.png";